import type { AppContent, FalconContent } from '../../../@types/interfaces';

export const normalizeContent = (content: AppContent | FalconContent): AppContent => {
  // If content is a mock or old NeMo just use it directly
  if (content.__type !== 'aem-headless') {
    return content;
  }

  return normalizeAemHeadlessContent(content);
};

const normalizeAemHeadlessContent = (content: FalconContent): AppContent => {
  const { fields } = content;

  if (!fields) {
    return {} as AppContent;
  }

  const {
    theme,
    paragraphs,
    bodyText,
    justification,
    ctaButtonLabel,
    ctaButtonUrl,
    ctaButtonOpenInNewTab,
    ariaLabel,
    consuptionAndEmission,
    disclaimer,
    bottomMargin,
    reduceTextWidth,
    headline,
    headlineOrder,
    headlineTag,
    enableSearch,
    sortBy,
    showPrice,
  } = fields;

  const contentForCMS: AppContent = {
    headline,
    headlineOrder,
    headlineTag,
    theme,
    bodyText,
    paragraphs,
    justification,
    ctaButtonLabel,
    ctaButtonUrl,
    ctaButtonOpenInNewTab,
    ariaLabel,
    consumptionAndEmission: consuptionAndEmission,
    disclaimer,
    bottomMargin,
    reduceTextWidth,
    enableSearch,
    sortBy,
    showPrice,
  };

  const formattedContent: AppContent = {
    ...contentForCMS,
  };

  return formattedContent;
};
